'use strict';

var pull = require('pull-stream');

var pushable = require('pull-pushable');

var batch = require('pull-batch');

var pullPair = require('pull-pair');

var through = require('pull-through');

var pullWrite = require('pull-write');

var pause = require('pull-pause');

module.exports = function trickleReduceToRoot(reduce, options) {
  var pair = pullPair();
  var result = pushable();
  var pausable = pause(function () {});
  var pendingResumes = 0;
  pull(pair.source, pausable, trickle(0, -1), batch(Infinity), pull.asyncMap(reduce), pull.collect(function (err, roots) {
    if (err) {
      result.end(err);
    } else {
      if (roots.length === 1) {
        result.push(roots[0]);
        result.end();
      } else if (roots.length > 1) {
        result.end(new Error('expected a maximum of 1 roots and got ' + roots.length));
      } else {
        result.end();
      }
    }
  }));
  return {
    sink: pair.sink,
    source: result
  };

  function trickle(indent, maxDepth) {
    var iteration = 0;
    var depth = 0;
    var deeper;
    var aborting = false;
    var result = pushable();
    return {
      source: result,
      sink: pullWrite(write, null, 1, end)
    };

    function write(nodes, callback) {
      var ended = false;
      var node = nodes[0];

      if (depth && !deeper) {
        deeper = pushable();
        pull(deeper, trickle(indent + 1, depth - 1), through(function (d) {
          this.queue(d);
        }, function (err) {
          if (err) {
            this.emit('error', err);
            return; // early
          }

          if (!ended) {
            ended = true;
            pendingResumes++;
            pausable.pause();
          }

          this.queue(null);
        }), batch(Infinity), pull.asyncMap(reduce), pull.collect(function (err, nodes) {
          pendingResumes--;

          if (err) {
            result.end(err);
            return;
          }

          nodes.forEach(function (node) {
            result.push(node);
          });
          iterate();
        }));
      }

      if (deeper) {
        deeper.push(node);
      } else {
        result.push(node);
        iterate();
      }

      callback();
    }

    function iterate() {
      deeper = null;
      iteration++;

      if (depth === 0 && iteration === options.maxChildrenPerNode || depth > 0 && iteration === options.layerRepeat) {
        iteration = 0;
        depth++;
      }

      if (!aborting && maxDepth >= 0 && depth > maxDepth || aborting && !pendingResumes) {
        aborting = true;
        result.end();
      }

      if (!pendingResumes) {
        pausable.resume();
      }
    }

    function end(err) {
      if (err) {
        result.end(err);
        return;
      }

      if (deeper) {
        if (!aborting) {
          aborting = true;
          deeper.end();
        }
      } else {
        result.end();
      }
    }
  }
};